import * as _ from 'lodash';
import { fetchWrapper } from './FetchWrapper';

/**
 * Master data option structure returned from backend
 * Used for dropdown lists with code and name fields
 */
export interface MasterDataOption {
    code: string;
    name: string;
}

/**
 * API caller for fetching master data from public endpoints
 * These endpoints do not require authentication
 */
export const MasterDataApiCaller = {
    requestBaseUrl: '/api/public/masterData',

    /**
     * Get Marketplace master data options
     * @returns Array of { code, name } for marketplaces
     * Example: [{ code: 'SHOPEE', name: 'Shopee Malaysia' }, ...]
     */
    getMarketplaceOptions: async (): Promise<MasterDataOption[]> => {
        const response = await fetchWrapper.get(`${MasterDataApiCaller.requestBaseUrl}/marketplace`, '');
        return MasterDataApiCaller.handleResponseResultList(response);
    },

    /**
     * Get Currency master data options
     * @returns Array of { code, name } for currencies
     * Example: [{ code: 'USD', name: 'US Dollar' }, ...]
     */
    getCurrencyOptions: async (): Promise<MasterDataOption[]> => {
        const response = await fetchWrapper.get(`${MasterDataApiCaller.requestBaseUrl}/currency`, '');
        return MasterDataApiCaller.handleResponseResultList(response);
    },

    /**
     * Get Category master data options
     * @returns Array of { code, name } for product categories
     * Example: [{ code: 'ELECTRONICS', name: 'Electronics' }, ...]
     */
    getCategoryOptions: async (): Promise<MasterDataOption[]> => {
        const response = await fetchWrapper.get(`${MasterDataApiCaller.requestBaseUrl}/category`, '');
        return MasterDataApiCaller.handleResponseResultList(response);
    },

    handleResponseResultMap: (response: any): Object => {
        return _.get(response, 'result', {});
    },
    handleResponseResultList: (response: any): any[] => {
        return _.get(response, 'result', []);
    }
};
